import 'regenerator-runtime/runtime'
import customSelect from 'custom-select'
import scrollToElement from './modules/scrollToElement'
// import numberCounter from './modules/counter'
import { initAccordionNodes } from './modules/accordion'
import fixedNavbar from './modules/fixedNavbar'
import HesGallery from './modules/hes-gallery'
import amazingScroll from './modules/amazingScroll'
import amazingScrollSlider from './modules/amazingScrollSlider'
// import Expand from './modules/Expand'
// import Popups from './modules/Popups'
// import { InputFactory } from './modules/Input'

var animationList = {
	'fade-top': 'top:-100px->0; transition:all 0s->all 1s; opacity:0->1;',
	'fade-right': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s',
	'fade-bottom': 'bottom:-100px->0; transition:all 1s; opacity:0->1;',
	'fade-left': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s',
	'fade-left-top': 'opacity: 0->1; left:-50px->0; top:-50px->0; transition:all 0s->all 1s',
	'fade-left-bottom': 'opacity: 0->1; left:-50px->0; bottom:-50px->0; transition:all 0s->all 1s',
	'opacity': 'opacity: 0->1; transition:all 0s->all 1s',
	'enlarge': 'transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s',
	'shrink': 'transform:scale(1)->scale(0.5); opacity: 0->1; transition:all 0s->all 1s',
	'rotate': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s'
}

document.addEventListener('DOMContentLoaded', function () {
	// Karuzele Bootstrap
	const Carousel = require('./modules/carousel.js').default
	const carousels = [...document.querySelectorAll('.carousel')]
	if (carousels.length) {
		carousels.forEach(node => new Carousel(node))
	}

	// Akordiony Bootstrap
	const Collapse = require('./modules/collapse.js').default
	const collapses = [...document.querySelectorAll('[data-toggle="collapse"]')]
	if (collapses.length) {
		collapses.forEach(node => new Collapse(node))
	}
	// Własne selecty
	customSelect('select.custom-select')

	if (window.innerWidth >= 1200) {
		scrollToElement(document.querySelector('nav.navbar').offsetHeight)
	} else {
		scrollToElement(document.getElementById('header').offsetHeight)
	}

	// Licznik wyłączony
	// numberCounter()

	HesGallery.setOptions({
		disableScrolling: false,
		hostedStyles: false,
		animations: true,

		showImageCount: true,
		wrapAround: true
	})
	if (window.innerWidth >= 1200) {
		window.animate = amazingScroll({
			start: {
				visibleAfterLoading: true,
				waitForScroll: {
					on: false,
					ratio: 0
				}
			},
			animation: animationList
		})

		const selectors = ['.carousel']
		selectors.forEach(selector => {
			amazingScrollSlider(selector, animationList)
		})
}
	const accordionNodes = document.querySelectorAll('.accordion-wrapper')
	if (accordionNodes) {
		initAccordionNodes(accordionNodes)
	}
})
class CollapseMobile {
	constructor (wrapper) {
		this.CollapseMobile = wrapper
		this.button = wrapper.querySelector('.collapse-button')
		this.content = wrapper.querySelector('.collapse-content')
		// this.height = [...this.content.children].map(el => el.offsetHeight).reduce((acc, curr) => acc + curr, 50)+'px' // tam gdzie 50 marginy wewnetrzne
		this.renderListener()
	}
	renderListener () {
		this.button.addEventListener('click', () => this.toggle())
	}

	toggle () {
		if (this.content.offsetHeight !== 0) {
			this.content.style.maxHeight = null
			this.button.classList.remove('full')
		} else {
			this.content.style.maxHeight = this.content.scrollHeight + 'px'
			this.button.classList.add('full')
		}
	}
}
// Wymienic na zakomentowane przy uzywaniu
document.addEventListener('DOMContentLoaded', () => {
	const elements = [...document.querySelectorAll('.collapse')]
	if (elements.length) {
		elements.forEach(el => {
			window.collapse = new CollapseMobile(el)
		})
	}
})
// wylaczenie linkow
// document.addEventListener('DOMContentLoaded', function () {
// 	[...document.querySelectorAll('a:not([href*="#"])')]
// 		.filter(e => !e.classList.contains('our-projects__item'))
// 		.forEach(el => el.setAttribute('href', '#!'))
// })



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/script.js